
import Vue from "vue";

export default Vue.extend({
  name: "TempStarsTableTitle",
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      default: null
    }
  }
});
